module.exports = __webpack_public_path__ + "img/icon-email.740dcf59.svg";